// extracted by mini-css-extract-plugin
export default {"menuWrapper":"DropdownMenu_menuWrapper__VVtp1","menuOptionsContainer":"DropdownMenu_menuOptionsContainer__t4z25","listContainer":"DropdownMenu_listContainer__NbdmY"};